export const APPROVE = 'approve';
export const REJECT = 'reject';
export const REVOKE = 'revoke';
